import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { toast } from "../../../components/AppModal/AppModal";
import HelperService from '../../../utility/HelperService';
import { CgClose } from 'react-icons/cg';
import { Label } from '../../../components/Label/Label';
import { useForm } from "react-hook-form";
import "../../../components/AppModal/ModalKit.css";

const ArcheivedGoalsPopUp = (props: any) => {

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors },
    } = useForm();
    const [reason, setReason] = useState<any>();
    return (<>
        <Transition.Root show={props.open2} as={Fragment}>
            <Dialog as="div" className="relative z-[1050]" initialFocus={props.cancelButtonRef} onClose={props.setOpen2}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-[1050] overflow-y-auto">
                    {/* <form onSubmit={handleSubmit(props.DeleteReason)}> */}
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="fpm-panel fpm-sm">
                                <button
                                    type="button"
                                    className="fpm-x"
                                    onClick={() => {
                                        props.setOpen2(false)
                                        props.setDeletedData('')
                                    }}
                                >
                                    <CgClose size={17} />
                                </button>
                                <div className="fpm-modal">
                                    <div className="fpm-head">
                                        <div className="fpm-badge fpm-badge-amber">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="4" rx="1" /><path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8" /><path d="M10 12h4" /></svg>
                                        </div>
                                        <Dialog.Title as="h2">
                                            Archive Goal
                                        </Dialog.Title>
                                        <p>Goal : {props.deletedData.value}</p>
                                    </div>
                                    <div className="fpm-body form-style">
                                        {(props.isMapped) &&
                                            <p style={{ color: '#b94a48', marginBottom: 10 }}>Assets are mapped for this goal. If you proceed, all assets will be unmapped for this goal and it will be archived.</p>
                                        }
                                        <label className="label mb-0 mr-4">Please mention the reason for archiving : <span className=" text-red-600">*</span></label>
                                        <div className="sh-seg mt-3">
                                            {['Goal is achieved', 'Goal is canceled'].map((opt) => (
                                                <button
                                                    type="button"
                                                    key={opt}
                                                    className={"sh-seg-opt" + (reason === opt ? " on" : "")}
                                                    onClick={() => setReason(opt)}
                                                >
                                                    {opt}
                                                </button>
                                            ))}
                                        </div>
                                        <div>
                                            {props.errors.reason && (
                                                <Label title={"Please Select Reason for archiving."} modeError={true} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="fpm-foot">
                                        <button
                                            type="button"
                                            className="fpm-btn"
                                            onClick={() => {
                                                props.setOpen2(false)
                                                props.setDeletedData('')
                                            }
                                            }
                                        >Cancel</button>
                                        <button
                                            type="submit"
                                            className="fpm-btn-brand fpm-btn-amber"
                                            ref={props.cancelButtonRef}
                                            onClick={() => {
                                                props.DeleteReason(reason)
                                            }
                                            }
                                        >
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    {/* </form> */}
                </div>
            </Dialog>
        </Transition.Root>
    </>);
}
export default ArcheivedGoalsPopUp;
